(function( $ ) {
   "use strict";
    
   var $window         = $(window),
   $document           = $(document);

   var windowWidth     = $window.width();

   var $html           = $('html'),
   $body               = $('body'),
   IsScreen767Smaller  = (windowWidth < 768),
   BEEstrings          = window.BEEstrings,
   $overlay            = $('.bee-close-overlay'),
   bee_lock_scroll     = 'bee-lock-scroll',
   attr_data_scroll    = '[data-bee-scroll-me]',
   page_type           = BEErequest.page_type,
   search_url          = BEEroutes.search_url,
   platform_email      = BEEconfigs.platform_email,
   enableConfetti      = BEEconfigs.enableConfetti,
   cacheNameFirst      = BEEThemeSP.cacheNameFirst,
   eventChange         = 'change:ajaxCart';

   // isTouch             = ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
   // BEEThemeSP.isHover  = $html.hasClass('beep-hover');
   // //BEEThemeSP.isHover  = (window.matchMedia("(hover: hover)").matches);
   // BEEThemeSP.isTouch  = !BEEThemeSP.isHover && isTouch;

   /**
    * Tooltip nathan
    * -----------------------------------------------------------------------------
    * https://jsfiddle.net/1duk9mys/
    * https://floating-ui.com/docs/offset
    *
    */

   /**
    * https://developers.google.com/web/updates/2017/09/sticky-headers
    */
   BEEThemeSP.Header = (function () {

        var headerStr    = '.bee-section-header',
        header           = document.querySelector(headerStr),
        headerBounds     = {},
        currentScrollTop = 0,
        preventReveal    = false,
        isScrolling      = 0,
        dt_header        = 'data-header-options',
        options          = $(header).find('['+dt_header+']').attr(dt_header) || '{}',
        options          = JSON.parse(options),
        isSticky         = options.isSticky,
        hideScroldown    = options.hideScroldown,
        html             = document.documentElement,
        str_action       = 'is-action__hover',
        $mainMenu        = $("[data-menu-nav]"),
        $hasChildren     = $mainMenu.find(">li.has--children"),
        $hasChildrenLinks,
        $subMenu         = $hasChildren.find('>.bee-sub-menu'),
        $header          = $(header),
        $siteWrapper     = $('.bee-website-wrapper'),
        str__offsets     = 'menu-has__offsets',
        str__calcSub     = 'calc-pos-submenu',
        isVertical       = $header.hasClass('header-vertical'),
        str__Main        = '.bee-is-header-categories-menu', // '#shopify-section-header-categories-menu',
        str__Cat         = '.bee-is-header-categories',  // '#shopify-section-header-categories',
        $categoriesMain  = $(str__Main),
        $categories      = $(str__Cat),
        extraSpace       = 10,
        childOpend       = 'is--child-open',
        noTransiton      = 'no-transiton-nav-a',
        isStuck          = 'is-header--stuck',
        timeDropdown     = 200,
        timeNoTransiton,
        updateHeaderBounds = true,
        strClickIcon     = BEEconfigs.onlyClickDropIcon ? '.bee-menu-item.has--children>a>.bee--menu-toggle' : '.bee-menu-item.has--children>a';
        function connectedCallback() {
            if (windowWidth <= 1024) {
                    return; // Non eseguire nulla su dispositivi mobili o tablet
                }
            if (!isSticky || (isSticky && hideScroldown) || isVertical ) return;
            // console.log('connectedCallback')
            
            // if (IsDesignMode) {

            // }
            let observer = new IntersectionObserver(function(entries) {
               // no intersection with screen
               if ( entries[0].intersectionRatio === 0 ) {

                   html.classList.add(isStuck);
                   if (updateHeaderBounds) {
                     html.classList.add('bee-hsticky__ready');
                     updateHeaderBounds = false;
                   }

               } else if( entries[0].intersectionRatio === 1 ) {
                  
                  // fully intersects with screen
                  html.classList.remove(isStuck);
                  html.classList.add(noTransiton);
                  clearTimeout(timeNoTransiton);
                  timeNoTransiton = setTimeout(() => {
                   html.classList.remove(noTransiton);
                  }, 366);

               }

            }, { threshold: [0,1] });
            if ($("#bee-hsticky__sentinel").length > 0) {
               observer.observe(document.querySelector("#bee-hsticky__sentinel"));
            }
            setTimeout(() => {
               html.classList.add('bee-hsticky__ready');
               updateHeaderBounds = false;
            }, 396);
        }

        function connectedCallbackScroldown() {

          if (IsDesignMode) {
            disconnectedCallback();
            header           = document.querySelector('.bee-section-header');
            headerBounds     = {};
            currentScrollTop = 0;
            preventReveal    = false;
            options          = $(header).find('['+dt_header+']').attr(dt_header) || '{}';
            options          = JSON.parse(options);
            isSticky         = options.isSticky;
            hideScroldown    = options.hideScroldown;
          }

          if (!isSticky || !hideScroldown || isVertical ) {
            header.classList.remove('shopify-section-header-hidden', 'animate');
            return;
          }

          //console.log('connectedCallbackScroldown')
          // onScroll()
          // preventReveal = true;

          header.addEventListener('preventHeaderReveal', hideHeaderOnScrollUp);
          window.addEventListener('scroll', onScroll, false);

          createObserver();
        }

        function hideHeaderOnScrollUp() {
         preventReveal = true;
        }

        function disconnectedCallback() {
          // console.log('disconnectedCallback')
          header.removeEventListener('preventHeaderReveal', hideHeaderOnScrollUp);
          window.removeEventListener('scroll', onScroll);
        }

        function createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            headerBounds = entries[0].intersectionRect;
            //console.log(headerBounds)
            observer.disconnect();
          });

          observer.observe(header);
        }

        function onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          
          // console.log(preventReveal)
          if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom) {
            requestAnimationFrame( hide );
          } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom) {
            if (!preventReveal) {
              requestAnimationFrame(reveal);
            } else {
              window.clearTimeout(isScrolling);
              isScrolling = setTimeout(() => {
                preventReveal = false;
              }, 366);
              // }, 66);
              requestAnimationFrame( hide );

            }
          } else if (scrollTop <= headerBounds.top) {
            requestAnimationFrame( reset );
          }

          currentScrollTop = scrollTop;
        }

        function hide() {
          header.dispatchEvent(new Event('BeeHeaderHide'));
          $header.one( 'transitionend webkitTransitionEnd oTransitionEnd', function( ) {
            if ( $header.hasClass('shopify-section-header-hidden') ) html.classList.remove(isStuck);
          });
          header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          closeMenuDisclosure();
          closeSearchModal();
        }

        function reveal() {
          header.dispatchEvent(new Event('BeeHeaderReveal'));
          html.classList.add(isStuck);
          header.classList.add('shopify-section-header-sticky', 'animate');
          header.classList.remove('shopify-section-header-hidden');
        }

         function reset() {
             html.classList.remove(isStuck);
             // Update headerBounds if when reload position not on header
             if (updateHeaderBounds && headerBounds.top == 0 && headerBounds.height == 0) {
               headerBounds = header.getBoundingClientRect();
               updateHeaderBounds = false
             }
             header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
             html.classList.add(noTransiton);
             clearTimeout(timeNoTransiton);
             timeNoTransiton = setTimeout(() => {
              html.classList.remove(noTransiton);
             }, 366);
         }

         function closeMenuDisclosure() {
          // this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          // this.disclosures.forEach(disclosure => disclosure.close());
         }

         function closeSearchModal() {
          // this.searchModal = this.searchModal || this.header.querySelector('details-modal');
          // this.searchModal.close(false);
         }

         function StickyInit() {
            connectedCallback();
            //disconnectedCallback();
            connectedCallbackScroldown();
            
            $html.css({
               '--topbar-height': ($('#bee-top-bar-main').height() || 0) + 'px',
               '--header-height': ($('.bee-section-header').height() || 0) + 'px'
             });

            $window.on('resize', function() {
              $html.css({
                '--topbar-height': ($('#bee-top-bar-main').height() || 0) + 'px',
                '--header-height': ($('.bee-section-header').height() || 0) + 'px'
              });
              // document.documentElement.style.setProperty('--topbar-height', document.getElementById('bee-top-bar-main').offsetHeight + 'px');
              // document.documentElement.style.setProperty('--header-height', document.querySelector('.bee-section-header').offsetHeight + 'px');
            });
         }
         
         // windowWidth $window.width()
         function LazyloadMega() {

            var $lazyMegaMenu = $('.bee-type__mega .bee-lazy_menu'),
                $listActive   = $('.bee-list-categories--item.is--active'),
                key_index     = $listActive.index(),
                key_id        = (key_index > 0) ? key_index : '',
                key_time      = cacheNameFirst+'timeMegaBee'+key_id,
                key_data      = cacheNameFirst+'dataMegaBee'+key_id,  
                timeCache     = isStorageSpSession ? (sessionStorage.getItem(key_time) || 0 ) : 0,
                timeCache     = parseInt(timeCache),
                timeConfig    = 30*60000, // convert 30 minute to milliseconds;
                str_mega_menu = 'bee-section-mega__menu',
                data_id       = '[data-section-id]';

            if ( $lazyMegaMenu.length == 0 || windowWidth < 1024) return;
            
            if (!IsDesignMode && timeCache > 0 && timeCache >= Date.now() ) {
              renderContentsMega($lazyMegaMenu, sessionStorage.getItem(key_data));
            } else {
               var $megaMenu = $('.'+str_mega_menu),
               list_id = $megaMenu.length > 0 ? $megaMenu.find(data_id).data('section-id') : 'mega-menu,mega-menu2',
               listActiveHref = $listActive.find('>a').attr('href');

               if (key_index > 0 && $megaMenu.length == 0 && location.pathname != listActiveHref) {

                  BEEThemeSP.getToFetchSection(null,'text',listActiveHref).then((response) => {
                     if ( response == 'NVT_94' ) {
                        return;
                     }
                     const section_id = $(response).find(`.${str_mega_menu} ${data_id}`).data('section-id');

                     if (!section_id) return;

                     fetchLazyloadMega(section_id);

                  });

               } else {
                  fetchLazyloadMega(list_id);
                  // BEEThemeSP.getToFetchSection('?sections='+list_id,'json').then((response) => {
                  //    if ( response == 'NVT_94' || response.status) {
                  //       if (response.status) console.error(response.description);
                  //       return;
                  //    }
                    //  var html = '';
                    //  for (const i in response) {
                    //       html +=  response[i].split('[nt_mega_split1]')[1];
                          
                    //  }
                    //  renderContentsMega($lazyMegaMenu, '<div>'+html+'</div>');
                    //  if (isStorageSpSession) {
                        // timeCache = Date.now() + timeConfig;
                    //     sessionStorage.setItem(key_time,timeCache);
                    //     sessionStorage.setItem(key_data,'<div>'+html+'</div>');
                    //  }
                  // });
               }

               function fetchLazyloadMega(id) {

                  BEEThemeSP.getToFetchSection('?sections='+id,'json').then((response) => {
                     if ( response == 'NVT_94' || response.status) {
                        if (response.status) console.error(response.description);
                        return;
                     }
                     var html = '';
                     for (const i in response) {
                          html +=  response[i].split('[nt_mega_split1]')[1];
                          
                     }
                     renderContentsMega($lazyMegaMenu, '<div>'+html+'</div>');
                     if (isStorageSpSession) {
                        timeCache = Date.now() + timeConfig;
                        sessionStorage.setItem(key_time,timeCache);
                        sessionStorage.setItem(key_data,'<div>'+html+'</div>');
                     }
                  });
               }
               // fetch(BEEThemeSP.root_url+'?sections=mega-menu,mega-menu2', {
               //  method: 'GET',
               //  headers: {
               //    'Cache-Control': 'no-cache'
               //  }
               // })
               // .then((response) => response.json())
               // .then((response) => {
               //  if (response.status) {
               //    console.error(response.description);
               //    return;
               //  }
               //  var html = '';
               //  for (const i in response) {
               //      html +=  response[i].split('[nt_mega_split1]')[1];
                    
               //  }
               //  renderContentsMega($lazyMegaMenu, '<div>'+html+'</div>');
               //  if (isStorageSpSession) sessionStorage.setItem('bee-mega-contents','<div>'+html+'</div>');

               // })
               // .catch((e) => {
               //    console.error(e);
               // });
               // .finally(() => {
               //     $this.removeClass(classes.loading).removeAttr('aria-disabled');
               // });
            }
         }

         function renderContentsMega($lazyMegaMenu, html) {
if (windowWidth <= 1024) {
                    return; // Non eseguire nulla su dispositivi mobili o tablet
                }
            //console.log(html)
            var $html = $(html);
            //console.log($html);
            $lazyMegaMenu.each(function( index ) {

               var $this    = $(this),
               $flickitybee,
               id           = '#bee-mega-contents'+$this.data('id'),
               dataHtml     = $html.find(id).html();
               
               //console.log(id, $html.find(id) )
               // console.log(dataHtml)
               if ( !dataHtml ) {
                  $this.html('');
                  return
               }
               $this.html( dataHtml );
               
               if ($this.find('.bee-products .bee-product').length > 0) {
                  BEEThemeSP.reinitProductGridItem();
               }

               // console.log('xx',$this.closest('.has--children'))
               setTimeout(function(){ 
                  if ( $this.hasClass('isotopebee') ) BEEThemeSP.Isotopebee.init($this);
                  calcPositionSubmenu( $this.closest('.has--children') );
                  BEEThemeSP.PopupMFP();

                  $flickitybee = $this.find('.flickitybee-later');
                  if ( $flickitybee.length == 0 ) return;

                  $flickitybee.each(function( index ) {
                     this.flickitybee = new BEEThemeSP.Carousel( this );
                     //BEEThemeSP.Flickitybee.init( $(this) );
                  });

               }, 600);

            });
            setTimeout(function() {
              $header.find('.isotopebee-enabled').isotopebee('layout');
            }, 800);
         }
         
         function clickDropdownOpen(that) {
            //console.log( that.find(strClickIcon) )
            that.find(strClickIcon).off('click').on('click', function(e) {

               e.preventDefault();

               var $this = $(this);
               if ( $this.hasClass('bee--menu-toggle') ) $this = $this.closest('a');
               
               if ( $this.hasClass(childOpend) ) {
                 $this.removeClass(childOpend).siblings('ul').slideUp(timeDropdown);
               } else {
                 //$this.parent().siblings('.has--children').find('.'+childOpend).removeClass(childOpend).siblings('ul').slideUp(timeDropdown);
                 $this.addClass(childOpend).siblings('ul').slideDown(timeDropdown);
               }
            });
         }

         function LazyloadDropdown() {
            if (windowWidth <= 1024) {
                    return; // Non eseguire nulla su dispositivi mobili o tablet
                }
            // new+sale
            var $lazyDropMenu = $('.bee-type__drop .bee-lazy_menu'),
                $listActive   = $('.bee-list-categories--item.is--active'),
                key_index     = $listActive.index(),
                key_id        = (key_index > 0) ? key_index : '',  
                key_time      = cacheNameFirst+'timeDropBee'+key_id,
                key_data      = cacheNameFirst+'dataDropBee'+key_id,
                timeCache     = isStorageSpSession ? (sessionStorage.getItem(key_time) || 0 ) : 0,
                timeCache     = parseInt(timeCache),
                timeConfig    = 30*60000; // convert 30 minute to milliseconds;

            if (IsDesignMode) {
                  $lazyDropMenu.each(function( index ) {
                     calcPositionSubmenu( $(this).closest('.has--children') );
                     clickDropdownOpen( $(this) );
                  });
            }

            if ( $lazyDropMenu.length == 0 || windowWidth < 1024 || IsDesignMode ) return;

            if ( timeCache > 0 && timeCache >= Date.now() ) {
              var ArrHtml = sessionStorage.getItem(key_data).split('[nt_drop_split2]');
               $lazyDropMenu.each(function( index ) {
                  $(this).html( ArrHtml[index] );
                  calcPositionSubmenu( $(this).closest('.has--children') );
                  clickDropdownOpen( $(this) );
               });

            } else {

               var HandleList = [];
               $lazyDropMenu.each(function( index ) {
                  HandleList.push( $(this).data('handle') );
               });
               HandleList = '/'+HandleList.join('+');
               // console.log('HandleList', HandleList)

               BEEThemeSP.getToFetchSection(null,'text',`${window.BEEroutes.all_url}${HandleList}/?section_id=dropdown-menu`).then((response) => {
                  if ( response == 'NVT_94' ) return;

                  var html = response.split('[nt_drop_split1]')[1],
                  ArrHtml = html.split('[nt_drop_split2]');
                  
                  $lazyDropMenu.each(function( index ) {
                     $(this).html( ArrHtml[index] );
                     calcPositionSubmenu( $(this).closest('.has--children') );
                     clickDropdownOpen( $(this) );
                  });
                  if (isStorageSpSession) {
                     timeCache = Date.now() + timeConfig;
                     sessionStorage.setItem(key_time,timeCache);
                     sessionStorage.setItem(key_data,'<div>'+html+'</div>');
                  }
               });
               // fetch(`${window.BEEroutes.all_url}${HandleList}/?section_id=dropdown-menu`, {
               //  method: 'GET',
               //  headers: {
               //    'Cache-Control': 'no-cache'
               //  }
               // })
               // .then((response) => response.text())
               // .then((response) => {

               //    var html = response.split('[nt_drop_split1]')[1],
               //    ArrHtml = html.split('[nt_drop_split2]');
                  
               //    $lazyDropMenu.each(function( index ) {
               //       $(this).html( ArrHtml[index] );
               //       calcPositionSubmenu( $(this).closest('.has--children') );
               //    });

                 //  if (isStorageSpSession) {
                     // timeCache = Date.now() + timeConfig;
                 //     sessionStorage.setItem(key_time,timeCache);
                 //     sessionStorage.setItem(key_data,html);
                 //  }
               // })
               // .catch((e) => {
               //    console.error(e);
               // });
            }
         }

         function menuHoverIntent(_hasChildren) {

           if (_hasChildren) $hasChildren = _hasChildren;
           //if ( BEEThemeSP.isTouch || windowWidth < 1024 || $hasChildren.length == 0 ) return;
           if ( windowWidth < 1024 || $hasChildren.length == 0 ) return;
            
            var HoverInterval = 35,  // 20
            HoverTimeout      = 150;    // 70

            $hasChildren.each(function (e, i) {
                var $this = $(this)
                $this.hoverIntent({
                    sensitivity: 3,
                    interval: HoverInterval,
                    timeout: HoverTimeout,
                    over: function (t) {
                       $this.addClass(str_action);
                    },
                    out: function () {
                       $this.removeClass(str_action);
                    },
                });
            });
         }

         function menuClickIntent(_hasChildren) {
            
            if (_hasChildren) {
               $hasChildrenLinks = _hasChildren.find('>a');
            } else {
               $hasChildrenLinks = $hasChildren.find('>a');
            }
            
            if ( BEEThemeSP.isHover || windowWidth < 1024 || $hasChildrenLinks.length == 0 ) {
               $hasChildrenLinks.off('click.menu click.menuIntent');
               return;
            }

            $hasChildrenLinks.on('click.menu', function (e) {
               e.preventDefault();
               let $parent = $(this).parent();

               if ( $parent.hasClass(str_action) ) {
                   $parent.removeClass(str_action);
                   $document.off('click.menuIntent');

               } else {
                  $parent.addClass(str_action).siblings().removeClass(str_action);
                  $document.on('click.menuIntent', function (e) {
                     var target = e.target;

                     // console.log($(target).is('.'+str_action) , $(target).parents('li').is('.'+str_action))
                     if ( !$(target).is('.'+str_action) && !$(target).parents('li').is('.'+str_action) ) {
                        //console.log('click.menu')
                        $mainMenu.find('.' + str_action).removeClass(str_action);
                        $document.off('click.menuIntent');
                        //return false;
                     }
                  });
               }

            });

         }
         
         // calc-pos-submenu
         function calcPositionSubmenuInt(__hasChildren, oneRun) {
           
            if (__hasChildren) $hasChildren = __hasChildren;
            if ( windowWidth < 1024 || $hasChildren.length == 0 ) return;

            if (IsDesignMode) $header = $(headerStr);

            $hasChildren.each(function (e, i) {
               
               calcPositionSubmenu( $(this), oneRun );
               //clickDropdownOpen( $(this) );
               
            });
            $header.addClass(str__calcSub)

         }

         function calcWidthHeight() {

            if ( $window.width() < 1024 ) return;

            if (IsDesignMode) $header = $(headerStr);
            
            // Update maxw max-h header
            
            $header.removeAttr('style').css({
               '--bee-max-width' : `${$window.width() - 10}px`,
               '--bee-max-height': `${$window.height() - Math.max(0,header.getBoundingClientRect().top) - Math.max(0,header.offsetHeight) - 20}px`
               //'--bee-max-height': `${$window.height() - $header.offset().top - $header.height() - 20}px`
            });
            $header.find('.isotopebee-enabled').isotopebee('layout');
            setTimeout(function() {
              $header.find('.isotopebee-enabled').isotopebee('layout');
            }, 500);

            // Update maxw max-h categories Menu
            var $navCategories = $('#bee-nav-categories');
            //console.log('calcWidthHeight',$navCategories)
            if ($navCategories.length == 0) return;

            $navCategories.removeAttr('style').css({
               // '--bee-max-width' : `${$window.width() - $navCategories.offset().left - $navCategories.width()}px`,
               // '--bee-max-height': `${$window.height() - $navCategories.offset().top  - 10}px`
               '--bee-max-width' : `${$window.width() - Math.max(0,$navCategories[0].getBoundingClientRect().left) - $navCategories.width()}px`,
               '--bee-max-height': `${$window.height() - Math.max(0,$navCategories[0].getBoundingClientRect().top) - 10}px`
            });
            //console.log($navCategories.find('.isotopebee-enabled'))
            $navCategories.find('.isotopebee-enabled').isotopebee('layout');
            setTimeout(function() {
              $navCategories.find('.isotopebee-enabled').isotopebee('layout');
            }, 500);

            //$window.width() - $navCategories.offset().left - $navCategories.width()
         }

         function calcPositionSubmenu($this, oneRun = false) {
           console.log("windowWidth");
                 console.log(windowWidth);
                if (windowWidth <= 1024) {
                    return; // Non eseguire nulla su dispositivi mobili o tablet
                }
               var a     = $this.find('>a')[0],
               sub       = $this.find('>.bee-sub-menu')[0],
               placement = $this.data('placement') || 'bottom';

               if ( $this.hasClass('menu-width__full') && placement != 'right-start' || !sub ) return
               // console.log($(sub))

               // remove style CSS
               $(sub).attr('style', '');
               //https://floating-ui.com/docs/autoUpdate
                //console.log('calcPositionSubmenu',oneRun)
               //async function update() {

                  if (placement == 'bottom' && !$this.hasClass('bee-type__drop')) {
                     if ( calcCenterSubmenu(sub,a) ) return;
                  }
                  FloatingUIBeeDOM.computePosition(a, sub, {
                      placement: placement,
                      middleware: [
                        // FloatingUIBeeDOM.offset(6),
                        FloatingUIBeeDOM.flip({
                          //fallbackPlacements: ['left', 'right', 'top', 'bottom'],
                          // fallbackPlacements: ['bottom-start','bottom-end'],
                        }), 
                        FloatingUIBeeDOM.shift({padding: 5}),
                        // FloatingUIBeeDOM.arrow({element: arrowElement}),
                      ]
                  }).then(({x, y, placement, middlewareData}) => {
                     console.log(placement)
                    console.log(middlewareData)
                     Object.assign(sub.style, {
                       // left: (placement.indexOf('right') !== -1) ? '100%' : `${x}px`,
                       // top:  (placement.indexOf('right') !== -1) ? `${y}px` : '100%',
                       left: `${x+40}px`,
                       top:  (placement.indexOf('bottom') > -1) ? '73%' : `${y}px`,
                     });

                  });

                  if (!oneRun) {
                     // console.log($(sub))
                     // let $grid = $(sub).find('.bee-lazy_menu.isotopebee');
                     let $grid = $(sub).find('.bee-lazy_menu.isotopebee.isotopebee-enabled');
                     //console.log($grid,'ass')
                     if ( $grid.length > 0 ) $grid.isotopebee('layout');
                  }
               // }
               // update();
               
               // if (!window.ResizeObserver || oneRun) {
               //    update();
               //    return;
               // }

               // const cleanup = FloatingUIBeeDOM.autoUpdate(a, sub, update, {
               //    // elementResize: true,
               //    // ancestorResize: true
               // });

               
         }

         function calcCenterSubmenu(sub) {
            // console.log( sub )
            var $sub  = $(sub);
            $sub.attr('style', '');

            var nav_dropdownWidth = $sub.outerWidth(),
            nav_dropdownOffset    = $sub.offset();

            if( ! nav_dropdownWidth || ! nav_dropdownOffset ) return false;
            var nav_dropdownLeft   = nav_dropdownOffset.left,
            nav_dropdownLeftCenter = (windowWidth - nav_dropdownWidth)/2;

            //console.log(nav_dropdownLeftCenter, nav_dropdownLeft, nav_dropdownLeftCenter + nav_dropdownWidth)
            // console.log( nav_dropdownLeftCenter, nav_dropdownLeft, (nav_dropdownLeft + nav_dropdownWidth) )
            // console.log( nav_dropdownLeft, nav_dropdownLeftCenter )
            if ( !isThemeRTL && nav_dropdownLeftCenter <= nav_dropdownLeft && nav_dropdownLeft <= (nav_dropdownLeftCenter+nav_dropdownWidth) && windowWidth >= (nav_dropdownLeftCenter + nav_dropdownWidth) ) {
               $sub.addClass('is--center-screen');
               return true;
            } else if ( isThemeRTL && nav_dropdownLeftCenter <= (nav_dropdownLeft + nav_dropdownWidth) && nav_dropdownLeft <= nav_dropdownLeftCenter && windowWidth >= (nav_dropdownLeftCenter + nav_dropdownWidth) ) {
               $sub.addClass('is--center-screen');
               return true;
            } else {
               $sub.removeClass('is--center-screen');
               return false;
            }
            
            // if( nav_dropdownWidth < 0) return;
            // //console.log('center');
            // var toLeft = ( nav_dropdownOffset.left + (nav_dropdownWidth/2) ) - windowWidth/2;
            // console.log(dropdownOffsetRight, nav_dropdownOffset.left ,nav_dropdownWidth/2, windowWidth/2)
            // if (isThemeRTL) {
            //       $sub.css({
            //           right: toLeft
            //       });
            // } else {
            //       $sub.css({
            //           left: - toLeft
            //       });
            // }
            //return isThemeRTL ? toLeft : - toLeft;
         }

         function fetchUpdateCategories() {

              // $categoriesMain  = $('#shopify-section-header-categories-menu');
              // $categories      = $('#shopify-section-header-categories');
            if ($categoriesMain.find('[data-wrapper-categories]').length == 0) return;
             
            if (!IsDesignMode && $categories.length == 0) {

               var key_time = cacheNameFirst+'timeCatBee',
                key_data    = cacheNameFirst+'dataCatBee',  
                timeCache   = isStorageSpSession ? (sessionStorage.getItem(key_time) || 0 ) : 0,
                timeCache   = parseInt(timeCache),
                timeConfig  = 30*60000; // convert 30 minute to milliseconds;
               
               if ( timeCache > 0 && timeCache >= Date.now() ) {
                  updateCategoriesHTML(sessionStorage.getItem(key_data))
               } else {

                  BEEThemeSP.getToFetchSection(null,'text',search_url+'/?section_id=header-categories').then((section) => {
                     if ( section == 'NVT_94' ) return;
                     //$(section).html()
                     var DomHTMl = new DOMParser().parseFromString(section, 'text/html').querySelector('div').innerHTML;
                     updateCategoriesHTML(DomHTMl)
                     if (isStorageSpSession) {
                        timeCache = Date.now() + timeConfig;
                        sessionStorage.setItem(key_time,timeCache);
                        sessionStorage.setItem(key_data,DomHTMl);
                     }
                  });
                  // fetch( search_url+'/?section_id=header-categories' )
                  // .then(function(response) {
                  //   return response.text();
                  // })
                  // .then(function(section) {
                  //    //$(section).html()
                  //    var DomHTMl = new DOMParser().parseFromString(section, 'text/html').querySelector('div').innerHTML;
                  //    updateCategoriesHTML(DomHTMl)
                    //  if (isStorageSpSession) {
                        // timeCache = Date.now() + timeConfig;
                    //     sessionStorage.setItem(key_time,timeCache);
                    //     sessionStorage.setItem(key_data,DomHTMl);
                    //  }

                  // })
                  // .catch(function(error) {
                  //   // eslint-disable-next-line no-console
                  //   console.log(error);
                  // });

               }

            } else if (IsDesignMode) {
               $categoriesMain  = $(str__Main);
               $categories      = $(str__Cat);
              updateCategoriesHTML( $categories.html() );
            }
         }

         function updateCategoriesHTML(DomHTMl, $headerWrapperCategories) {
               var $categoriesCat = (typeof $headerWrapperCategories == 'undefined') ? $categoriesMain.find('[data-wrapper-categories]') : $headerWrapperCategories;

               $categoriesCat.html( DomHTMl );
                calcWidthHeight();
               //console.log(DomHTMl)
               var _hasChildren2 = $categoriesCat.find('#bee-nav-categories>.has--children');
               // console.log(_hasChildren2)

               menuHoverIntent(_hasChildren2);
               menuClickIntent(_hasChildren2);

               document.addEventListener('theme:hover', function(evt) {
                   menuClickIntent(_hasChildren2);
               });

               calcPositionSubmenuInt(_hasChildren2);
               setTimeout(() => {
                 calcPositionSubmenuInt(_hasChildren2);
               }, 1000);

               $categoriesCat.find('.bee-type__drop .bee-lazy_menu').each(function( index ) {
                  clickDropdownOpen( $(this) );
               });

               if ($categoriesCat.find('.bee-products .bee-product').length > 0) {
                  BEEThemeSP.reinitProductGridItem();
               }

               var $isotopebee = $categoriesCat.find('.isotopebee-later'),
               $flickitybee    = $categoriesCat.find('.flickitybee-later');

               if ( $isotopebee.length > 0 ) {

                  $isotopebee.each(function( index ) {
                     BEEThemeSP.Isotopebee.init( $(this) );;
                  });
               }

               
               if ( $isotopebee.length > 0 ) {

                  $flickitybee.each(function( index ) {
                     this.flickitybee = new BEEThemeSP.Carousel( this );
                  });
               }
               // setTimeout(function() {
             //      $window.on('resize.cat', 
             //         BEEThemeSP.debounce(
               //          300, 
               //          function() {
               //             calcPositionSubmenuInt(_hasChildren2);
               //          }
             //        )
             //      );
               // }, 2000);

         }
         

         function init(_hasChildren) {
           if (window.innerWidth <= 1024) {
                    return; // Non eseguire nulla su dispositivi mobili o tablet
                }
            calcPositionSubmenuInt(_hasChildren, true);

            setTimeout(function() {
               $window.on('resize.menu', 
                  calcWidthHeight
               );
            }, 2000);
         }

         return {
           stickyInit: StickyInit,
           init: init,
           updateCat: updateCategoriesHTML
         };

   })();

})( jQuery_BENT );

jQuery_BENT(document).ready(function() {
  // Header Lazyload Megamenu
  BEEThemeSP.Header.init();
});